import { useQuery } from "@tanstack/react-query"
import type { Invoice } from "@tfg/db"

import { httpClient } from "~/backend/axios.ts"

export const useOrganizationInvoicesQuery = () => {
  return useQuery<Invoice[]>(["invoices"], async () => {
    const response = await httpClient.get("invoices")
    return response.data
  })
}
